"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var shared_1 = require("@formily/shared");
var core_1 = require("@formily/core");
var shared_2 = require("../shared");
var useForceUpdate_1 = require("./useForceUpdate");
var context_1 = __importDefault(require("../context"));
var extendMutators = function (mutators, props) {
    return __assign(__assign({}, mutators), { change: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            args[0] = shared_1.isFn(props.getValueFromEvent)
                ? props.getValueFromEvent.apply(props, args) : args[0];
            mutators.change.apply(mutators, args.map(function (event) { return shared_2.getValueFromEvent(event); }));
        }, blur: function () {
            mutators.blur();
            if (props.triggerType === 'onBlur') {
                mutators.validate({ throwErrors: false });
            }
        } });
};
var INSPECT_PROPS_KEYS = [
    'props',
    'rules',
    'required',
    'editable',
    'visible',
    'display'
];
exports.useField = function (options) {
    var forceUpdate = useForceUpdate_1.useForceUpdate();
    var ref = react_1.useRef({
        field: null,
        unmounted: false,
        subscriberId: null,
        uid: null
    });
    var form = react_1.useContext(context_1.default);
    if (!form) {
        throw new Error('Form object cannot be found from context.');
    }
    var mutators = react_1.useMemo(function () {
        var initialized = false;
        ref.current.field = form.registerField(options);
        ref.current.subscriberId = ref.current.field.subscribe(function (fieldState) {
            if (ref.current.unmounted)
                return;
            if (initialized) {
                if (options.triggerType === 'onChange') {
                    if (ref.current.field.hasChanged('value')) {
                        mutators.validate({ throwErrors: false });
                    }
                }
                if (!form.isHostRendering()) {
                    forceUpdate();
                }
            }
        });
        ref.current.uid = Symbol();
        initialized = true;
        return extendMutators(form.createMutators(ref.current.field), options);
    }, [options.name, options.path]);
    react_1.useEffect(function () {
        var cacheProps = ref.current.field.getCache(ref.current.uid);
        if (cacheProps) {
            var props_1 = shared_2.inspectChanged(cacheProps, options, INSPECT_PROPS_KEYS);
            if (props_1) {
                ref.current.field.setState(function (state) {
                    shared_1.merge(state, props_1, {
                        assign: true,
                        arrayMerge: function (target, source) { return source; }
                    });
                });
            }
            ref.current.field.setCache(ref.current.uid, options);
        }
        else {
            ref.current.field.setCache(ref.current.uid, options);
        }
    });
    react_1.useEffect(function () {
        ref.current.field.setState(function (state) {
            state.mounted = true;
        }, !ref.current.field.state.unmounted);
        form.notify(core_1.LifeCycleTypes.ON_FIELD_MOUNT, ref.current.field);
        ref.current.unmounted = false;
        return function () {
            ref.current.field.removeCache(ref.current.uid);
            ref.current.unmounted = true;
            ref.current.field.unsubscribe(ref.current.subscriberId);
            ref.current.field.setState(function (state) {
                state.unmounted = true;
            });
        };
    }, []);
    var state = ref.current.field.getState();
    return {
        form: form,
        field: ref.current.field,
        state: state,
        mutators: mutators,
        props: state.props
    };
};
exports.default = exports.useField;
